// extracted by mini-css-extract-plugin
export default {"webViewVehicleDetailsPageContainer":"_curated-vehicle-details-page_webViewVehicleDetailsPageContainer__qhxb0"};